module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('center', [_c('ul', {
    staticClass: "pagination no-margin"
  }, [_c('li', {
    class: {
      'disabled': this.previousDisabled
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.previousPage($event)
      }
    }
  }, [_c('span', [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.pagination.totalPages), function(page, index) {
    return _c('li', {
      class: {
        'active': index + 1 === _vm.pagination.currentPage
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToPage(index + 1)
        }
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': this.nextDisabled
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('span', [_vm._v("»")])])])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb8af0b","hasScoped":false}!./src/app/components/pagination/pagination.html
// module id = 3059
// module chunks = 1